//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderStatuses', {
//        templateUrl: 'views/components/views/orderStatuses/orderStatuses.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['orderStatusesService', function (orderStatusesService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListOrderStatuses: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadOrderStatuses() {
//                vm.model.itemsListOrderStatuses = await orderStatusesService.listOrderStatuses();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadOrderStatuses();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
